var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 2.04541C5.46859 2.04541 4.95988 2.25612 4.58481 2.6312C4.20974 3.00627 3.99902 3.51498 3.99902 4.04541V20.0454C3.99902 20.5758 4.20974 21.0846 4.58481 21.4596C4.95988 21.8347 5.46859 22.0454 5.99902 22.0454H17.999C18.5295 22.0454 19.0382 21.8347 19.4132 21.4596C19.7883 21.0846 19.999 20.5758 19.999 20.0454V8.04541L13.999 2.04541H5.99902ZM5.99902 4.04541H12.999V9.04541H17.999V20.0454H5.99902V4.04541ZM7.99902 12.0454V14.0454H15.999V12.0454H7.99902ZM7.99902 16.0454V18.0454H12.999V16.0454H7.99902Z",
    fill: "#7687A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperwork);
export default __webpack_public_path__ + "static/media/paperwork.dca75d5d1c2cc8cf55470721e6ddc045.svg";
export { ForwardRef as ReactComponent };